<template>
	<div class="shopCar px16 layui-layout layui-layout-admin" style="background:#fff;overflow-y:auto;max-height:100%;" v-if="show">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="back" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i>订单结算
			</div>
		</div>
		<div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">钢网规格</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">钢片规格</th>
							<th class="align_center">钢片有效切割面积</th>
							<th class="align_center">单价</th>
							<th class="align_center">数量</th>
							<th class="align_center">毛重/个</th>
							<th class="align_center">交付类型</th>
							<th class="align_center">其他产品</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.attr_title}}</td>
							<td>{{item.use_title}}</td>
							<td>{{parseFloat(item.money) + parseFloat(item.pay_type_price)}}</td>
							<td>{{item.buy_num}}</td>
							<td>{{item.weight}}kg</td>
							<td>{{item.is_fast_text}}</td>
							<td>{{item.other_product_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">工艺要求</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">制作要求</th>
							<th class="align_center">交付类型</th>
							<th class="align_center">激光打标</th>
							<th class="align_center">钢网工艺</th>
							<th class="align_center">制作工艺</th>
							<th class="align_center">钢片厚度</th>
							<th class="align_center">Mark基准点</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.make_demand_text}}</td>
							<td>{{item.is_fast_text}}</td>
							<td>{{item.laser_marking_text}}</td>
							<td>{{item.mesh_purpose_text}}</td>
							<td>{{item.mark_craft_text}}</td>
							<td>{{item.attr_info_title}}</td>
							<td>{{item.mark_point_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">CHIP开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔工艺</th>
							<th class="align_center">开孔类型</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">防锡珠类型</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.mesh_purpose_text}}</td>
							<td>{{item.solder_hole_text}}</td>
							<td>{{item.solder_hole_size_text}}</td>
							<td>{{item.solder_hole_type_text ? item.solder_hole_type_text : item.glue_hole_type_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">IC集成电路开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔宽度</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i" v-if="item.mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.ic_open_ask_text}}</td>
							<td>{{item.ic_open_ask_size_text}}</td>
							<td>{{item.ic_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">BGA封装开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔直径</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i" v-if="item.mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.bga_open_ask_text}}</td>
							<td>{{item.bga_open_ask_size_text}}</td>
							<td>{{item.bga_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">散热PAD</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔形状</th>
							<th class="align_center">开孔面积</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i" v-if="item.mesh_type == 1">
							<td>{{i + 1}}</td>
							<td>{{item.pad_open_shape_text}}</td>
							<td>{{item.pad_open_area_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">其他制作要求和工程文件</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">工程文件</th>
							<th class="align_center">其他要求说明</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in datas" :key="i">
							<td>{{i+1}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.pdf_file" style="color: rgb(72, 118, 255);">工程包.zip</a>
							</td>
							<td>{{item.message ? item.message : '无'}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">收货地址&订单联系人</div>
				<div class="addressInfo">
					<div class="address">
						<p style="width: 130px;">收货地址：</p>
						<div class="msg" v-if="address != ''">
							<div class="msg-top">{{address.name}}，{{address.mobile}}</div>
							<div class="msg-bottom">{{address.province}}{{address.city}}{{address.area}}{{address.address}}</div>
						</div>
						<div v-else>
							请选择收货地址
						</div>
						<button class="layui-btn otherBtn" @click="selAddress">其他地址<i class="layui-icon-right layui-icon" style="margin-left:10px;"></i></button>
					</div>
					<div class="linkman">
						<p style="width: 130px;">订单联系人：</p>
						<div class="msg" v-if="contact != ''">
							<div class="msg-top">{{contact.name}}</div>
							<div class="msg-bottom">{{contact.mobile}}</div>
						</div>
						<div v-else>
							请选择订单联系人
						</div>
						<button class="layui-btn otherBtn" @click="selContact">其他联系人<i class="layui-icon-right layui-icon" style="margin-left:10px;"></i></button>
					</div>
				</div>
			</div>
			<div v-if="kd_info.length > 0">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">快递信息</div>
				<div class="courier">
					<div class="label">选择快递：</div>
					<div class="sel_kd" style="flex-direction: column;">
						<div @click="checkedIndex(i)" class="pointer" v-for="(item,i) in kd_info" v-if="item.use_status" style="line-height: 2;display: flex;align-items: center;">
							<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
							<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
							<span style="display: inline-block;width: 100px;margin-left: 5px;">{{item.company}}</span>
							<span style="color: #999999;font-size: 12px;" v-show="item.company != '自提' && item.company != '自配送'">{{item.type==1?'市内':item.type==2?'省内':'省外'}} 首重({{item.initial_weight}}KG){{item.freight}}元   续重{{item.excess_freight}}元/KG</span>
							<span style="color: #999999;font-size: 12px;" v-show="(item.company == '自提' || item.company == '自配送') && item.freight > 0">{{item.freight}}元/件</span>
						</div>
					</div>
				</div>
				<div class="courier">
					<div class="label">
						配送费用：
					</div>
					<div style="margin-left: 20px;">{{kd_money}}元</div>
				</div>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">订单合计</div>
				<div class="courier" v-if='tax > 0'>
					<div class="label">订单金额： </div><span style="color: rgb(255, 152, 0);">{{parseFloat(price) + kd_money + tax}}</span>元 (钢网{{price}}元+运费{{kd_money}}元+税点{{tax}}元)
				</div>
				<div class="courier" v-else>
					<div class="label">订单金额：</div> <span style="color: rgb(255, 152, 0);">{{parseFloat(price) + kd_money}}</span>元 (钢网{{price}}元+运费{{kd_money}}元)
				</div>
				<div class="courier" v-if="userInfo.pay_type == 1">
					<div class="label">账户桃币：</div><span style="color: rgb(255, 152, 0);">{{score}}</span>
				</div>
			</div>
			<div class="f_row al_itm" style="padding: 12px 12px 30px 30px;font-size: 18px;" v-if="userInfo.pay_type == 2">
				<div style="margin-right:20px;min-width:70px;">支付方式：</div>
				<div @click="setPayclass(1)" style="margin-right:40px;" class="f_row al_itm pointer px16">
					<i v-show="pay_type == 1" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="pay_type != 1" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					<img class="icons" src="../assets/wchat.png" height="28" width="28" alt="" style="margin: 0 10px;">
					<span>微信支付</span>
				</div>
				<div @click="setPayclass(2)" class="f_row al_itm pointer px16">
					<i v-show="pay_type == 2" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="pay_type != 2" class="layui-icon-circle layui-icon px20 zt_txt_color"></i>
					<img class="icons" src="../assets/aply.png" height="28" width="28" alt="" style="margin: 0 10px;">
					<span>支付宝支付</span>
				</div>
			</div>
		</div>
		<button class="pay" @click="onPay">确认支付</button>
		<!--弹出层-->
		<div id="address" style="display: none;margin: 20px 30px 60px 30px;">
			<table class="layui-table" lay-skin="nob">
				<colgroup>
					<col width="150">
					<col width="200">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center"></th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">地址</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in addressArr" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center" style="width:40%;">{{item.province+ item.city + item.area + item.address}}</td>
						<td class="align_center">
							<span @click="setTheAddr(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if='addressArr == [] || addressArr.length == 0 || !addressArr' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
		</div>
		<!--弹出层-->
		<div id="contact" style="display: none;margin: 20px 30px 60px 30px;">
			<table class="layui-table" lay-skin="nob">
				<colgroup>
					<col width="150">
					<col width="200">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center"></th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in contactArr" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center">
							<span @click="setTheContact(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if='contactArr == [] || contactArr.length == 0 || !contactArr' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
		</div>
		<div id="qrCode" style="display: none;">
			<img :src="'https://mr.summary88.com/'+imgUrl" />
			<p>请打开微信扫码支付</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'shopCar',
		data() {
			return {
				show: false,
				id: 0,
				price: 0,
				tax: 0,
				datas: [],
				layerss: '',
				address: '',
				contact: '',
				addressArr: [],
				contactArr: [],
				kd_info: [], //选择快递
				kd_index: 0,
				kd_type: 0,
				kd_money: 0,
				hideICBGAPAD: true,
				pay: true,
				clear: '',
				userInfo: '',
				imgUrl: '', //二维码url
				pay_type: 1,
			}
		},
		created() {
			let id = this.$route.query.id || '';
			this.id = id;
			let _this = this;
			api.getMemberInfo({ //获取会员信息
				token: _this.getCookie('token')
			}).then((res) => {
				if(res.code == 1) {
					_this.userInfo = res.data;
				} else if(res.code == 0) {
					layer.msg(res.msg, {
						icon: 2,
						anim: 6
					})
				}
			});
			this.getData(id);
		},
		mounted() {
			layui.use(['layer'], () => {
				this.layerss = layui.layer;
			});
		},
		methods: {
			setPayclass(num) {
				this.pay_type = num;
			},
			back() {
				this.$router.replace({
					path: '/shopCar'
				})
			},
			expressDetail(item) {
				let _this = this;
				this.kd_index = 0;
				if(item.province && item.city) {
					let city = item.province + ',' + item.city
					api.expressDetail({ //快递公司列表
						token: this.getCookie('token'),
						provinces: city,
						lng: item.lng,
						lat: item.lat
					}).then((res) => {
						res.data.forEach(function(val, i) {
							val.checked = false;
							if(val.ix_prev == 1) {
								_this.kd_index = i;
							}
							val.freight = parseFloat(val.freight);
							if(val.ix_prev == 1) {
								val.checked = true;
							}
						})
						_this.kd_info = res.data;
						_this.checkedIndex(_this.kd_index);
					})
				} else {
					layer.msg('收货地址数据有误', {
						icon: 2,
						anim: 6
					})
				}
			},
			checkedIndex(index) { //计算快递费用
				this.kd_info.forEach(function(val, i) {
					val.checked = false;
					if(i == index) {
						val.checked = true;
					}
				})
				this.kd_index = index;
				this.kd_type = this.kd_info[index].type;
				//二期
				let weight = 0;
				let num = 0;
				this.datas.forEach((val, ind) => {
					weight += val.weight * val.buy_num;
					num += val.buy_num;
				})

				if(this.kd_info[index].company == '自配送' || this.kd_info[index].company == '自提') {
					this.kd_money = parseFloat(this.kd_info[index].freight * num);
				} else {
					if(this.kd_info[index].initial_weight > weight) { //规格重量*数量小于首重
						this.kd_money = parseFloat(this.kd_info[index].freight);
					} else { //规格重量*数量大于首重
						let shou_money = parseFloat(this.kd_info[index].freight);
						let xv_money = Math.ceil(weight - this.kd_info[index].initial_weight) * this.kd_info[index].excess_freight;
						this.kd_money = parseFloat(shou_money + xv_money);
					}
				}
				//二期-end
			},
			getData() {
				let _this = this;
				api.getShopCarList({
					token: this.getCookie('token'),
					ids: this.id,
				}).then((res) => {
					if(res.code == 1) {
						_this.datas = res.data.list;
						_this.score = res.data.score;
						for(let i = 0; i < res.data.list.length; i++) {
							_this.price += parseFloat(res.data.list[i].price);
						}
						_this.price = parseFloat(_this.price).toFixed(2);
						if(this.$store.state.invoice == 1) {
							_this.tax = parseFloat(_this.price * 0.13).toFixed(2);
							_this.tax = parseFloat(_this.tax);
						}
						_this.onHide();
						_this.onGetAddressMsg();
						_this.show = true;
					}
				})
			},
			onGetAddressMsg() {
				let _this = this;
				api.getAddressList({ //获取收货地址
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							if(res.data[i].is_default == 1) {
								_this.address = res.data[i];
								_this.expressDetail(res.data[i]);
							}
						}
					} else {
						layer.msg('获取默认收货地址失败', {
							icon: 2,
							anim: 6
						})
					}
				})
				api.getContactList({ //获取联系人
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							if(res.data[i].is_default == 1) {
								this.contact = res.data[i];
							}
						}
					} else {
						layer.msg('获取默认联系人失败', {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onHide() {
				if(this.datas.length == 1 && this.datas[0].mesh_type == 2) {
					this.hideICBGAPAD = false;
				} else if(this.datas.length > 1) {
					let hide = false;
					for(let i = 0; i < this.datas.length; i++) {
						if(this.datas[i].mesh_type == 1) {
							hide = true;
						}
					}
					this.hideICBGAPAD = hide;
				}
			},
			onPay() {
				let _this = this;
				if(this.address == '' || this.kd_info == []) {
					layer.msg('请选择收货地址', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(this.contact == '') {
					layer.msg('请选择订单联系人', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				let price = parseFloat(this.price) + parseFloat(this.kd_money) + parseFloat(this.tax);
				if(!this.pay) {
					return false
				}
				layui.use('layer', () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						title: '确认支付',
						content: `订单金额${price}元`,
						btn: ['确认支付', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							_this.pay = false;
							layer.closeAll();
							layer.msg('加载中', {
								icon: 16,
								shade: 0.01,
							});
							api.createShopCarOrder({
								token: _this.getCookie('token'),
								ids: _this.id,
								attr_id: _this.datas[0].attr_id,
								price: parseFloat(_this.price) + parseFloat(_this.kd_money),
								address_id: _this.address.id,
								contact_id: _this.contact.id,
								order_level: _this.datas[0].level,
								express_id: _this.kd_info[_this.kd_index].id,
								type: _this.kd_type
							}).then((res) => {
								_this.pay = true;
								if(res.code == 1) {
									if(_this.userInfo.pay_type == 2) {
										api.getOrderPay({
											token: _this.getCookie('token'),
											order_num: res.data,
											order_type: 1,
											pay_type: _this.pay_type
										}).then((res1) => {
											if(_this.pay_type == 1) {
												if(res1.code == 1) {
													_this.imgUrl = res1.data;
													layer.closeAll();
													layer.open({
														title: '支付',
														type: 1,
														content: $('#qrCode'),
														resize: false,
														success: function() {
															_this.verify(res.data);
														},
														cancel: function(index, layero) {
															_this.$router.replace({
																path: '/myOrder'
															})
															clearInterval(_this.clear);
														}
													});
												} else {
													layer.msg(res1.msg, {
														icon: 2,
														anim: 6
													})
												}
											} else {
												layer.closeAll();
												let divForm = document.getElementsByTagName('divform')
												if(divForm.length) {
													document.body.removeChild(divForm[0])
												}
												const div = document.createElement('divform');
												div.innerHTML = res1; // data就是接口返回的form 表单字符串
												document.body.appendChild(div);
												document.forms[0].submit();
											}
										})
									} else {
										api.payOrder({
											token: _this.getCookie('token'),
											order_num: res.data,
										}).then((res1) => {
											if(res1.code == 1) {
												layer.msg('支付成功', {
													icon: 1,
													anim: 5
												})
												setTimeout(() => {
													_this.$router.replace({
														path: '/myOrder'
													})
												}, 1500)
											} else {
												layer.msg(res1.msg, {
													icon: 2,
													anim: 6
												})
											}
										})
									}
								} else {
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}
							})
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				})
			},
			verify(num) {
				var _this = this;
				var i = 0;
				clearInterval(_this.clear);
				_this.clear = setInterval(() => {
					i++;
					api.checkPayStatus({
						token: this.getCookie('token'),
						order_type: 1,
						order_num: num
					}).then((res) => {
						if(res.code == 1) {
							clearInterval(_this.clear);
							layer.closeAll();
							layer.msg('支付成功', {
								icon: 1,
								anim: 5
							})
							_this.$router.replace({
								path: '/myOrder'
							})
						} else {
							if(i == 100) {
								_this.pay = true;
								clearInterval(_this.clear);
								layer.closeAll();
								layer.msg('支付超时', {
									icon: 2,
									anim: 6
								})
							}
						}
					})
				}, 3000)
			},
			selAddress() {
				let _this = this;
				layui.use(['layer', 'table'], () => {
					let layer = layui.layer;
					let table = layui.table;
					api.getAddressList({ //获取收货地址
						token: _this.getCookie('token'),
					}).then((res) => {
						if(res.code == 1) {
							_this.addressArr = res.data;
							layer.open({
								type: 1,
								title: '选择收货地址',
								content: $('#address'),
								shade: 0,
								area: '1000px'
							});
						} else {
							layer.msg('获取收货地址失败', {
								icon: 2,
								anim: 6
							})
						}
					})
				})
			},
			setTheAddr(item) {
				this.address = item;
				this.expressDetail(item);
				layer.closeAll();
			},
			selContact() {
				layui.use(['layer', 'table'], () => {
					let layer = layui.layer;
					let table = layui.table;
					api.getContactList({ //获取联系人
						token: this.getCookie('token')
					}).then((res) => {
						if(res.code == 1) {
							this.contactArr = res.data;
							layer.open({
								type: 1,
								title: '选择订单联系人',
								content: $('#contact'),
								shade: 0,
								area: '1000px'
							});
						} else {
							layer.msg('获取联系人失败', {
								icon: 2,
								anim: 6
							})
						}
					})
				})

			},
			setTheContact(item) {
				this.contact = item;
				layer.closeAll();
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#qrCode {
		width: 300px;
		padding: 20px 20px 50px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 30px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
	}
	
	.msg {
		margin-right: 15px;
		color: #3c3c3c;
		font-size: 16px;
		line-height: 30px;
	}
	
	.addressInfo {
		display: flex;
	}
	
	.address {
		flex: 1;
		border-right: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
		padding: 20px 30px;
	}
	
	.linkman {
		flex: 1;
		display: flex;
		align-items: center;
		padding: 20px 30px;
	}
	
	.otherBtn {
		margin-left: 20px;
		background: #4876FF !important;
	}
	
	.file-list {
		min-height: 25px;
		margin-bottom: 20px;
		padding-left: 20px;
	}
	
	.file-list:last-child {
		margin-bottom: 0;
	}
	
	.file-list .file-item {
		display: flex;
	}
	
	.progress ul li:last-child {
		padding-bottom: 0 !important;
	}
	
	.goutong {
		padding: 4px 8px;
		border: 1px solid;
		border-radius: 15px;
		margin-top: -5px;
	}
	
	.btn1 {
		background: rgb(139, 195, 74);
		border-radius: 15px;
		margin-top: -5px;
		cursor: pointer;
		padding: 0 15px;
		height: 30px;
		line-height: 30px;
		color: #fff;
		text-align: center;
		margin-left: 15px;
	}
	
	.btn2 {
		background: rgb(255, 152, 0);
		border-radius: 14px;
		margin-top: -2px;
		cursor: pointer;
		padding: 0 10px;
		font-size: 14px;
		height: 26px;
		height: 26px;
		color: #fff;
		text-align: center;
		margin-left: 0px;
	}
	
	.count_down {
		color: rgba(255, 152, 0, 1);
		display: flex;
		align-items: center;
	}
	
	.count_down span {
		margin-left: 10px;
		font-size: 18px;
	}
	
	.count_down .layui-icon {
		font-size: 24px;
		margin-left: 20px;
		color: rgba(255, 152, 0, 1);
	}
	
	.pay {
		display: block;
		width: 400px;
		height: 45px;
		color: rgb(255, 255, 255);
		background-color: rgb(229, 28, 35);
		border-radius: 0px;
		font-size: 20px;
		text-align: center;
		margin: 50px auto;
		cursor: pointer;
	}
	
	.shopCar {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 10% 10px;
	}
	
	.scektsBox {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
	}
	
	.courier {
		padding: 8px 30px;
		line-height: 50px;
		font-size: 18px;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
	}
	
	.courier .label {
		width: 110px;
	}
	
	.courier:last-child {
		border-bottom: none;
	}
	
	.courier .sel_kd {
		display: flex;
	}
	
	.courier .sel_kd div {
		margin-left: 20px;
	}
	
	#status1 {
		color: rgba(255, 152, 0, 1);
	}
	
	#status2 {
		color: rgba(255, 152, 0, 1);
	}
	
	#status3 {
		color: rgba(37, 155, 36, 1);
	}
	
	#status4 {
		color: rgba(37, 155, 36, 1);
	}
	
	#status5 {
		color: rgba(37, 155, 36, 1);
	}
	
	#status6 {
		color: rgba(63, 81, 181, 1);
	}
	
	.status p span {
		margin-left: 10px;
	}
	
	.cancel {
		display: inline-block;
		width: 73px;
		height: 24px;
		line-height: 24px;
		color: #fff;
		background-color: rgb(63, 81, 181);
		border-radius: 4px;
		font-size: 14px;
		text-align: center;
		margin-left: 10px;
	}
	
	.title {
		padding: 8px 30px;
		color: #fff;
		border-radius: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/payment.vue